var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage01Layer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 554",
    style: {
      enableBackground: "new 0 0 750 554"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{opacity:.2}.st1{opacity:.7025;fill:#00b3e2;enable-background:new}.st2{opacity:.7949;fill:#00b3e2;enable-background:new}.st3{opacity:.9194;fill:#00b3e2;enable-background:new}.st4{opacity:.17;fill:#00b3e2;enable-background:new}.st5{opacity:.3912;fill:#00b3e2;enable-background:new}.st6{opacity:.7985;fill:#00b3e2;enable-background:new}.st7{opacity:.2952;fill:#00b3e2;enable-background:new}.st8{opacity:.2379;fill:#00b3e2;enable-background:new}.st9{opacity:.7979;fill:#00b3e2;enable-background:new}.st10{opacity:.1923;fill:#00b3e2;enable-background:new}.st11{opacity:.2633;fill:#00b3e2;enable-background:new}.st12{opacity:.7567;fill:#00b3e2;enable-background:new}.st13{opacity:.8787;fill:#00b3e2;enable-background:new}.st14{opacity:.1063;fill:#00b3e2;enable-background:new}.st15{opacity:.4365;fill:#00b3e2;enable-background:new}.st16{opacity:.3093;fill:#00b3e2;enable-background:new}.st17{opacity:.8717;fill:#00b3e2;enable-background:new}.st18{opacity:.8894;fill:#00b3e2;enable-background:new}.st19{opacity:.3056;fill:#00b3e2;enable-background:new}.st20{opacity:.746;fill:#00b3e2;enable-background:new}.st21{opacity:.3495;fill:#00b3e2;enable-background:new}.st22{opacity:.1708;fill:#00b3e2;enable-background:new}.st23{opacity:.1487;fill:#00b3e2;enable-background:new}.st24{opacity:.6951;fill:#00b3e2;enable-background:new}.st25{opacity:.346;fill:#00b3e2;enable-background:new}.st26{opacity:.9638;fill:#00b3e2;enable-background:new}.st27{opacity:.9921;fill:#00b3e2;enable-background:new}.st28{opacity:.7875;fill:#00b3e2;enable-background:new}.st29{opacity:.9765;fill:#00b3e2;enable-background:new}.st30{opacity:.8713;fill:#00b3e2;enable-background:new}.st31{opacity:.671;fill:#00b3e2;enable-background:new}.st32{opacity:.8827;fill:#00b3e2;enable-background:new}.st33{opacity:.825;fill:#00b3e2;enable-background:new}.st34{opacity:.5029;fill:#00b3e2;enable-background:new}.st35{opacity:.5864;fill:#00b3e2;enable-background:new}.st36{opacity:.6291;fill:#00b3e2;enable-background:new}.st37{opacity:.3205;fill:#00b3e2;enable-background:new}.st38{opacity:.3617;fill:#00b3e2;enable-background:new}.st39{opacity:.4051;fill:#00b3e2;enable-background:new}.st40{opacity:.7428;fill:#00b3e2;enable-background:new}.st41{opacity:.9725;fill:#00b3e2;enable-background:new}.st42{opacity:.9119;fill:#00b3e2;enable-background:new}.st43{opacity:.7001;fill:#00b3e2;enable-background:new}.st44{opacity:.1403;fill:#00b3e2;enable-background:new}.st45{opacity:.8896;fill:#00b3e2;enable-background:new}.st46{opacity:.2847;fill:#00b3e2;enable-background:new}.st47{opacity:.6772;fill:#00b3e2;enable-background:new}.st48{opacity:.7086;fill:#00b3e2;enable-background:new}.st49{opacity:.9521;fill:#00b3e2;enable-background:new}.st50{opacity:.7336;fill:#00b3e2;enable-background:new}.st51{opacity:.1865;fill:#00b3e2;enable-background:new}.st52{opacity:.4474;fill:#00b3e2;enable-background:new}.st53{opacity:.4603;fill:#00b3e2;enable-background:new}.st54{opacity:.2974;fill:#00b3e2;enable-background:new}.st55{opacity:.363;fill:#00b3e2;enable-background:new}.st56{opacity:.2678;fill:#00b3e2;enable-background:new}.st57{opacity:.2305;fill:#00b3e2;enable-background:new}.st58{opacity:.5805;fill:#00b3e2;enable-background:new}.st59{opacity:.3965;fill:#00b3e2;enable-background:new}.st60{opacity:.6819;fill:#00b3e2;enable-background:new}.st61{opacity:.9615;fill:#00b3e2;enable-background:new}.st62{opacity:.8102;fill:#00b3e2;enable-background:new}.st63{opacity:.9744;fill:#00b3e2;enable-background:new}.st64{opacity:.167;fill:#00b3e2;enable-background:new}.st65{opacity:.4419;fill:#00b3e2;enable-background:new}.st66{opacity:.98;fill:#00b3e2;enable-background:new}.st67{opacity:.1968;fill:#00b3e2;enable-background:new}.st68{opacity:.2405;fill:#00b3e2;enable-background:new}.st69{opacity:.8213;fill:#00b3e2;enable-background:new}.st70{opacity:.4383;fill:#00b3e2;enable-background:new}.st71{opacity:.6094;fill:#00b3e2;enable-background:new}.st72{opacity:.2278;fill:#00b3e2;enable-background:new}.st73{opacity:.7166;fill:#00b3e2;enable-background:new}.st74{opacity:.332;fill:#00b3e2;enable-background:new}.st75{opacity:.5511;fill:#00b3e2;enable-background:new}.st76{opacity:.2587;fill:#00b3e2;enable-background:new}.st77{opacity:.4756;fill:#00b3e2;enable-background:new}.st78{opacity:.7647;fill:#00b3e2;enable-background:new}.st79{opacity:.1642;fill:#00b3e2;enable-background:new}.st80{opacity:.877;fill:#00b3e2;enable-background:new}.st81{opacity:.7703;fill:#00b3e2;enable-background:new}.st82{opacity:.1783;fill:#00b3e2;enable-background:new}.st83{opacity:.6628;fill:#00b3e2;enable-background:new}.st84{opacity:.6963;fill:#00b3e2;enable-background:new}.st85{opacity:.3399;fill:#00b3e2;enable-background:new}.st86{opacity:.4171;fill:#00b3e2;enable-background:new}.st87{opacity:.2074;fill:#00b3e2;enable-background:new}.st88{opacity:.2879;fill:#00b3e2;enable-background:new}.st89{opacity:.9578;fill:#00b3e2;enable-background:new}.st90{opacity:.6855;fill:#00b3e2;enable-background:new}.st91{opacity:.9815;fill:#00b3e2;enable-background:new}.st92{opacity:.2348;fill:#00b3e2;enable-background:new}.st93{opacity:.243;fill:#00b3e2;enable-background:new}.st94{opacity:.9561;fill:#00b3e2;enable-background:new}.st95{opacity:.2179;fill:#00b3e2;enable-background:new}.st96{opacity:.6348;fill:#00b3e2;enable-background:new}.st97{opacity:.1876;fill:#00b3e2;enable-background:new}.st98{opacity:.7398;fill:#00b3e2;enable-background:new}.st99{opacity:.4712;fill:#00b3e2;enable-background:new}.st100{opacity:.789;fill:#00b3e2;enable-background:new}.st101{opacity:.3236;fill:#00b3e2;enable-background:new}.st102{opacity:.2763;fill:#00b3e2;enable-background:new}.st103{opacity:.1836;fill:#00b3e2;enable-background:new}.st104{opacity:.9593;fill:#00b3e2;enable-background:new}.st105{opacity:.8542;fill:#00b3e2;enable-background:new}.st106{opacity:.7408;fill:#00b3e2;enable-background:new}.st107{opacity:.4289;fill:#00b3e2;enable-background:new}.st108{opacity:.6895;fill:#00b3e2;enable-background:new}.st109{opacity:.5204;fill:#00b3e2;enable-background:new}.st110{opacity:.9642;fill:#00b3e2;enable-background:new}.st111{opacity:.9505;fill:#00b3e2;enable-background:new}.st112{opacity:.8059;fill:#00b3e2;enable-background:new}.st113{opacity:.7886;fill:#00b3e2;enable-background:new}.st114{opacity:.8379;fill:#00b3e2;enable-background:new}.st115{opacity:.8164;fill:#00b3e2;enable-background:new}.st116{opacity:.7388;fill:#00b3e2;enable-background:new}.st117{opacity:.8051;fill:#00b3e2;enable-background:new}.st118{opacity:.7155;fill:#00b3e2;enable-background:new}.st119{opacity:.3358;fill:#00b3e2;enable-background:new}.st120{opacity:.7929;fill:#00b3e2;enable-background:new}.st121{opacity:.8824;fill:#00b3e2;enable-background:new}.st122{opacity:.7046;fill:#00b3e2;enable-background:new}.st123{opacity:.3523;fill:#00b3e2;enable-background:new}.st124{opacity:.8439;fill:#00b3e2;enable-background:new}.st125{opacity:.8596;fill:#00b3e2;enable-background:new}.st126{opacity:.8764;fill:#00b3e2;enable-background:new}.st127{opacity:.1862;fill:#00b3e2;enable-background:new}.st128{opacity:.3869;fill:#00b3e2;enable-background:new}.st129{opacity:.799;fill:#00b3e2;enable-background:new}.st130{opacity:.6955;fill:#00b3e2;enable-background:new}.st131{opacity:.9375;fill:#00b3e2;enable-background:new}.st132{opacity:.9981;fill:#00b3e2;enable-background:new}.st133{opacity:.2773;fill:#00b3e2;enable-background:new}.st134{opacity:.1189;fill:#00b3e2;enable-background:new}.st135{opacity:.732;fill:#00b3e2;enable-background:new}.st136{opacity:.3817;fill:#00b3e2;enable-background:new}.st137{opacity:.1835;fill:#00b3e2;enable-background:new}.st138{opacity:.7591;fill:#00b3e2;enable-background:new}.st139{opacity:.136;fill:#00b3e2;enable-background:new}.st140{opacity:.9203;fill:#00b3e2;enable-background:new}.st141{opacity:.3911;fill:#00b3e2;enable-background:new}.st142{opacity:.5775;fill:#00b3e2;enable-background:new}.st143{opacity:.5884;fill:#00b3e2;enable-background:new}.st144{opacity:.6183;fill:#00b3e2;enable-background:new}.st145{opacity:.4279;fill:#00b3e2;enable-background:new}.st146{opacity:.3246;fill:#00b3e2;enable-background:new}.st147{opacity:.8402;fill:#00b3e2;enable-background:new}.st148{opacity:.3494;fill:#00b3e2;enable-background:new}.st149{opacity:.1555;fill:#00b3e2;enable-background:new}.st150{opacity:.1772;fill:#00b3e2;enable-background:new}.st151{opacity:.5217;fill:#00b3e2;enable-background:new}.st152{opacity:.7272;fill:#00b3e2;enable-background:new}.st153{opacity:.656;fill:#00b3e2;enable-background:new}.st154{opacity:.1959;fill:#00b3e2;enable-background:new}.st155{opacity:.4221;fill:#00b3e2;enable-background:new}.st156{opacity:.9686;fill:#00b3e2;enable-background:new}.st157{opacity:.7138;fill:#00b3e2;enable-background:new}.st158{opacity:.3281;fill:#00b3e2;enable-background:new}.st159{opacity:.4618;fill:#00b3e2;enable-background:new}.st160{opacity:.7805;fill:#00b3e2;enable-background:new}.st161{opacity:.2215;fill:#00b3e2;enable-background:new}.st162{opacity:.195;fill:#00b3e2;enable-background:new}.st163{opacity:.3992;fill:#00b3e2;enable-background:new}.st164{opacity:.3079;fill:#00b3e2;enable-background:new}.st165{opacity:.6155;fill:#00b3e2;enable-background:new}.st166{opacity:.8808;fill:#00b3e2;enable-background:new}.st167{opacity:.9997;fill:#00b3e2;enable-background:new}.st168{opacity:.3976;fill:#00b3e2;enable-background:new}.st169{opacity:.8669;fill:#00b3e2;enable-background:new}.st170{opacity:.8494;fill:#00b3e2;enable-background:new}.st171{opacity:.9397;fill:#00b3e2;enable-background:new}.st172{opacity:.1157;fill:#00b3e2;enable-background:new}.st173{opacity:.4199;fill:#00b3e2;enable-background:new}.st174{opacity:.537;fill:#00b3e2;enable-background:new}.st175{opacity:.399;fill:#00b3e2;enable-background:new}.st176{opacity:.9701;fill:#00b3e2;enable-background:new}.st177{opacity:.6907;fill:#00b3e2;enable-background:new}.st178{opacity:.6996;fill:#00b3e2;enable-background:new}.st179{opacity:.4459;fill:#00b3e2;enable-background:new}.st180{opacity:.9246;fill:#00b3e2;enable-background:new}.st181{opacity:.579;fill:#00b3e2;enable-background:new}.st182{opacity:.56;fill:#00b3e2;enable-background:new}.st183{opacity:.1931;fill:#00b3e2;enable-background:new}.st184{opacity:.3291;fill:#00b3e2;enable-background:new}.st185{opacity:.3328;fill:#00b3e2;enable-background:new}.st186{opacity:.1807;fill:#00b3e2;enable-background:new}.st187{opacity:.6098;fill:#00b3e2;enable-background:new}.st188{opacity:.7479;fill:#00b3e2;enable-background:new}.st189{opacity:.1891;fill:#00b3e2;enable-background:new}.st190{opacity:.5827;fill:#00b3e2;enable-background:new}.st191{opacity:.7149;fill:#00b3e2;enable-background:new}.st192{opacity:.4208;fill:#00b3e2;enable-background:new}.st193{opacity:.8497;fill:#00b3e2;enable-background:new}.st194{opacity:.5973;fill:#00b3e2;enable-background:new}.st195{opacity:.1009;fill:#00b3e2;enable-background:new}.st196{opacity:.8822;fill:#00b3e2;enable-background:new}.st197{opacity:.3257;fill:#00b3e2;enable-background:new}.st198{opacity:.3568;fill:#00b3e2;enable-background:new}.st199{opacity:.4989;fill:#00b3e2;enable-background:new}.st200{opacity:.2504;fill:#00b3e2;enable-background:new}.st201{opacity:.2338;fill:#00b3e2;enable-background:new}.st202{opacity:.778;fill:#00b3e2;enable-background:new}.st203{opacity:.9985;fill:#00b3e2;enable-background:new}.st204{fill:url(#SVGID_1_)}.st205{fill:url(#SVGID_2_)}.st206{fill:url(#SVGID_3_)}.st207{fill:url(#SVGID_4_)}.st208{fill:url(#SVGID_5_)}.st209{fill:url(#SVGID_6_)}.st210{fill:url(#SVGID_7_)}.st211{fill:url(#SVGID_8_)}.st212{fill:url(#SVGID_9_)}.st213{fill:url(#SVGID_10_)}.st214{fill:url(#SVGID_11_)}.st215{fill:url(#SVGID_12_)}.st216{fill:url(#SVGID_13_)}.st217{fill:url(#SVGID_14_)}.st218{fill:url(#SVGID_15_)}.st219{fill:url(#SVGID_16_)}.st220{fill:url(#SVGID_17_)}.st221{fill:url(#SVGID_18_)}.st222{fill:url(#SVGID_19_)}.st223{fill:url(#SVGID_20_)}.st224{fill:url(#SVGID_21_)}.st225{fill:url(#SVGID_22_)}.st226{fill:url(#SVGID_23_)}.st227{fill:url(#SVGID_24_)}.st228{fill:url(#SVGID_25_)}.st229{fill:url(#SVGID_26_)}.st230{fill:url(#SVGID_27_)}.st231{fill:url(#SVGID_28_)}.st232{fill:url(#SVGID_29_)}.st233{fill:url(#SVGID_30_)}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.1 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S18 319.2 17.1 318.2zM22.6 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C22 316.9 22.6 315.9 22.6 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.4 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9.8-.4 1.3-.8 1.7-1.2h2.5v19.3h-3.3L33.4 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.3 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S45.1 319.2 44.3 318.2zM49.7 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C49.1 316.9 49.7 315.9 49.7 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.5 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C61.6 319.7 60.4 319.2 59.5 318.2zM65 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C64.4 316.9 65 315.9 65 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M74.8 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S75.6 319.2 74.8 318.2zM80.2 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C79.6 316.9 80.2 315.9 80.2 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M90 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C92.1 319.7 90.9 319.2 90 318.2zM95.5 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C94.9 316.9 95.5 315.9 95.5 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M105.3 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C107.4 319.7 106.2 319.2 105.3 318.2zM110.7 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C110.2 316.9 110.7 315.9 110.7 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M120.6 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C122.7 319.7 121.4 319.2 120.6 318.2zM126 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C125.4 316.9 126 315.9 126 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.8 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9.8-.4 1.3-.8 1.7-1.2h2.6v19.3H137L136.8 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M148.7 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L148.7 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M159.6 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S160.4 319.2 159.6 318.2zM165 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C164.4 316.9 165 315.9 165 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M175.8 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3H176L175.8 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M186.7 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C188.8 319.7 187.6 319.2 186.7 318.2zM192.1 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C191.6 316.9 192.1 315.9 192.1 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M202 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C204.1 319.7 202.8 319.2 202 318.2zM207.4 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C206.8 316.9 207.4 315.9 207.4 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M218.2 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L218.2 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M229.1 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S230 319.2 229.1 318.2zM234.6 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C234 316.9 234.6 315.9 234.6 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M245.3 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L245.3 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M257.2 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9.8-.4 1.3-.8 1.7-1.2h2.5v19.3h-3.3L257.2 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M269.1 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L269.1 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M280 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S280.9 319.2 280 318.2zM285.4 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C284.9 316.9 285.4 315.9 285.4 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M295.3 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S296.1 319.2 295.3 318.2zM300.7 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C300.1 316.9 300.7 315.9 300.7 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M311.5 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L311.5 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M323.4 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L323.4 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M334.3 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S335.1 319.2 334.3 318.2zM339.7 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C339.1 316.9 339.7 315.9 339.7 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M349.5 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C351.6 319.7 350.4 319.2 349.5 318.2zM355 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C354.4 316.9 355 315.9 355 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M365.8 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L365.8 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M376.7 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5S377.5 319.2 376.7 318.2zM382.1 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C381.5 316.9 382.1 315.9 382.1 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M391.9 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5S392.8 319.2 391.9 318.2zM397.4 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C396.8 316.9 397.4 315.9 397.4 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M407.2 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S408 319.2 407.2 318.2zM412.6 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C412.1 316.9 412.6 315.9 412.6 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M422.5 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C424.6 319.7 423.3 319.2 422.5 318.2zM427.9 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C427.3 316.9 427.9 315.9 427.9 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M437.7 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C439.8 319.7 438.6 319.2 437.7 318.2zM443.2 314.1v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C442.6 316.9 443.2 315.9 443.2 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M453 318.2c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C455.1 319.7 453.8 319.2 453 318.2zM458.4 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C457.8 316.9 458.4 315.9 458.4 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M469.2 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L469.2 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M481.1 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L481.1 303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M493 303.8c-.2.1-.7.3-1.7.6-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H493V303.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M509.3 314.1v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C508.7 316.9 509.3 315.9 509.3 314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M23.6 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L23.6 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M34.4 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C36.5 357.9 35.2 357.3 34.4 356.3zM39.8 352.2v-8.5c0-.8-.1-1.5-.3-2.1s-.7-.8-1.4-.8c-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C39.3 355 39.8 354.1 39.8 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M49.6 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C51.7 357.9 50.4 357.3 49.6 356.3zM55 352.2v-8.5c0-.8-.1-1.5-.3-2.1s-.7-.8-1.3-.8c-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C54.4 355 55 354.1 55 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M65.7 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2H69v19.3h-3.3V341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M77.5 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9.8-.4 1.3-.8 1.7-1.2h2.6v19.3h-3.3L77.5 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M88.3 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C90.4 357.9 89.2 357.3 88.3 356.3zM93.7 352.2v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C93.2 355 93.7 354.1 93.7 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M103.5 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C105.6 357.9 104.3 357.3 103.5 356.3zM108.9 352.2v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C108.3 355 108.9 354.1 108.9 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M118.6 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C120.8 357.9 119.5 357.3 118.6 356.3zM124.1 352.2v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C123.5 355 124.1 354.1 124.1 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M133.8 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C135.9 357.9 134.7 357.3 133.8 356.3zM139.3 352.2v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C138.7 355 139.3 354.1 139.3 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M150 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3H150V341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M160.8 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S161.6 357.3 160.8 356.3zM166.2 352.2v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C165.7 355 166.2 354.1 166.2 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M176.9 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L176.9 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M188.7 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L188.7 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M199.5 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C201.6 357.9 200.4 357.3 199.5 356.3zM205 352.2v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C204.4 355 205 354.1 205 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M215.7 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L215.7 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M227.5 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L227.5 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M239.3 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L239.3 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M250.1 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C252.2 357.9 250.9 357.3 250.1 356.3zM255.5 352.2v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C254.9 355 255.5 354.1 255.5 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M265.2 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C267.3 357.9 266.1 357.3 265.2 356.3zM270.7 352.2v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C270.1 355 270.7 354.1 270.7 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M281.4 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L281.4 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M293.2 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L293.2 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M304 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C306.1 357.9 304.8 357.3 304 356.3zM309.4 352.2v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C308.8 355 309.4 354.1 309.4 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M319.2 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5S320 357.3 319.2 356.3zM324.6 352.2v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C324 355 324.6 354.1 324.6 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M335.3 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L335.3 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M346.1 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C348.2 357.9 347 357.3 346.1 356.3zM351.5 352.2v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C351 355 351.5 354.1 351.5 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M361.3 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C363.4 357.9 362.1 357.3 361.3 356.3zM366.7 352.2v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C366.2 355 366.7 354.1 366.7 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M376.5 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C378.6 357.9 377.3 357.3 376.5 356.3zM381.9 352.2v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C381.3 355 381.9 354.1 381.9 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M392.6 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L392.6 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M404.4 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L404.4 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M415.2 356.3c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C417.3 357.9 416.1 357.3 415.2 356.3zM420.6 352.2v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C420.1 355 420.6 354.1 420.6 352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M431.3 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L431.3 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M443.1 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L443.1 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M454.9 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H455L454.9 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M466.7 341.9c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L466.7 341.9v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M29.7 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C31.8 396 30.6 395.5 29.7 394.5zM35.2 390.4v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C34.6 393.2 35.2 392.2 35.2 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M46 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H46V380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M56.9 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C59 396 57.8 395.5 56.9 394.5zM62.4 390.4v-8.5c0-.8-.1-1.5-.3-2.1s-.7-.8-1.3-.8c-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C61.8 393.2 62.4 392.2 62.4 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M72.2 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C74.3 396 73.1 395.5 72.2 394.5zM77.6 390.4v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C77.1 393.2 77.6 392.2 77.6 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M87.5 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S88.3 395.5 87.5 394.5zM92.9 390.4v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C92.4 393.2 92.9 392.2 92.9 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M102.8 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C104.9 396 103.6 395.5 102.8 394.5zM108.2 390.4v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C107.6 393.2 108.2 392.2 108.2 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M119 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9.8-.4 1.3-.8 1.7-1.2h2.6v19.3h-3.3L119 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M130 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C132.1 396 130.8 395.5 130 394.5zM135.4 390.4v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C134.8 393.2 135.4 392.2 135.4 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M145.2 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S146.1 395.5 145.2 394.5zM150.7 390.4v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C150.1 393.2 150.7 392.2 150.7 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M160.5 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C162.6 396 161.4 395.5 160.5 394.5zM166 390.4v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C165.4 393.2 166 392.2 166 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M175.8 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C177.9 396 176.7 395.5 175.8 394.5zM181.2 390.4v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C180.7 393.2 181.2 392.2 181.2 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M191.1 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C193.2 396 191.9 395.5 191.1 394.5zM196.5 390.4v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C196 393.2 196.5 392.2 196.5 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M206.4 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C208.5 396 207.2 395.5 206.4 394.5zM211.8 390.4v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C211.2 393.2 211.8 392.2 211.8 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M222.6 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L222.6 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M234.5 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L234.5 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M245.4 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C247.6 396 246.3 395.5 245.4 394.5zM250.9 390.4v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C250.3 393.2 250.9 392.2 250.9 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M260.7 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C262.8 396 261.6 395.5 260.7 394.5zM266.2 390.4v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2 .3.5.7.8 1.3.8C265.6 393.2 266.2 392.2 266.2 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M277 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H277V380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M288.9 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H289L288.9 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M300.8 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L300.8 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M311.7 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C313.8 396 312.6 395.5 311.7 394.5zM317.1 390.4v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C316.6 393.2 317.1 392.2 317.1 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M328 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H328V380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M339.9 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H340L339.9 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M350.8 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C352.9 396 351.6 395.5 350.8 394.5zM356.2 390.4v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C355.7 393.2 356.2 392.2 356.2 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M367 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H367V380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M378.9 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H379L378.9 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M390.8 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L390.8 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M402.7 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L402.7 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M413.7 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C415.8 396 414.5 395.5 413.7 394.5zM419.1 390.4v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C418.5 393.2 419.1 392.2 419.1 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M429.9 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H430L429.9 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M441.8 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L441.8 380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M452.7 394.5c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C454.8 396 453.6 395.5 452.7 394.5zM458.2 390.4v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C457.6 393.2 458.2 392.2 458.2 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M469 380.1c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H469V380.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M485.3 390.4v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C484.8 393.2 485.3 392.2 485.3 390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M11.8 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5S12.7 433.6 11.8 432.6zM17.3 428.5V420c0-.8-.1-1.5-.4-2.1s-.7-.8-1.4-.8c-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C16.7 431.3 17.3 430.4 17.3 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M27.1 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C29.3 434.1 28 433.6 27.1 432.6zM32.6 428.5V420c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C32 431.3 32.6 430.4 32.6 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M43.4 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L43.4 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M54.4 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C56.5 434.1 55.2 433.6 54.4 432.6zM59.8 428.5V420c0-.8-.1-1.5-.3-2.1s-.7-.8-1.3-.8c-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C59.2 431.3 59.8 430.4 59.8 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M69.7 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S70.5 433.6 69.7 432.6zM75.1 428.5V420c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C74.6 431.3 75.1 430.4 75.1 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M85 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C87.1 434.1 85.8 433.6 85 432.6zM90.4 428.5V420c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8S87 419.2 87 420v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C89.9 431.3 90.4 430.4 90.4 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M100.3 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C102.4 434.1 101.2 433.6 100.3 432.6zM105.7 428.5V420c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C105.2 431.3 105.7 430.4 105.7 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M115.6 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C117.7 434.1 116.5 433.6 115.6 432.6zM121 428.5V420c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C120.5 431.3 121 430.4 121 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M130.9 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C133 434.1 131.8 433.6 130.9 432.6zM136.3 428.5V420c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C135.8 431.3 136.3 430.4 136.3 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M147.2 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L147.2 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M159.1 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L159.1 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M170.1 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C172.2 434.1 170.9 433.6 170.1 432.6zM175.5 428.5V420c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C174.9 431.3 175.5 430.4 175.5 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M186.3 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L186.3 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M197.3 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C199.4 434.1 198.1 433.6 197.3 432.6zM202.7 428.5V420c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C202.1 431.3 202.7 430.4 202.7 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M212.6 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C214.7 434.1 213.4 433.6 212.6 432.6zM218 428.5V420c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C217.5 431.3 218 430.4 218 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M227.9 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C230 434.1 228.8 433.6 227.9 432.6zM233.3 428.5V420c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C232.8 431.3 233.3 430.4 233.3 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M243.2 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C245.3 434.1 244.1 433.6 243.2 432.6zM248.6 428.5V420c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C248.1 431.3 248.6 430.4 248.6 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M259.5 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L259.5 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M271.4 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L271.4 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M282.3 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5S283.2 433.6 282.3 432.6zM287.8 428.5V420c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C287.2 431.3 287.8 430.4 287.8 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M297.7 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C299.8 434.1 298.5 433.6 297.7 432.6zM303.1 428.5V420c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C302.5 431.3 303.1 430.4 303.1 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M313.9 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3H314L313.9 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M324.9 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C327 434.1 325.7 433.6 324.9 432.6zM330.3 428.5V420c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C329.8 431.3 330.3 430.4 330.3 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M341.2 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L341.2 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M352.1 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C354.2 434.1 353 433.6 352.1 432.6zM357.5 428.5V420c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C357 431.3 357.5 430.4 357.5 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M368.4 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L368.4 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M380.3 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L380.3 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M392.2 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L392.2 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M403.2 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C405.3 434.1 404 433.6 403.2 432.6zM408.6 428.5V420c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C408 431.3 408.6 430.4 408.6 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M418.5 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5S419.3 433.6 418.5 432.6zM423.9 428.5V420c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C423.4 431.3 423.9 430.4 423.9 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M434.8 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L434.8 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M445.7 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C447.8 434.1 446.6 433.6 445.7 432.6zM451.2 428.5V420c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C450.6 431.3 451.2 430.4 451.2 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M461 432.6c-.9-1-1.3-2.4-1.3-4.1V420c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C463.1 434.1 461.9 433.6 461 432.6zM466.5 428.5V420c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C465.9 431.3 466.5 430.4 466.5 428.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M477.3 418.2c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L477.3 418.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M14.9 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C17 472.3 15.8 471.8 14.9 470.8zM20.3 466.6v-8.5c0-.8-.1-1.5-.4-2.1s-.7-.8-1.4-.8c-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C19.8 469.5 20.3 468.5 20.3 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M30.1 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C32.2 472.3 31 471.8 30.1 470.8zM35.5 466.6v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C35 469.5 35.5 468.5 35.5 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M45.3 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S46.2 471.8 45.3 470.8zM50.7 466.6v-8.5c0-.8-.1-1.5-.3-2.1s-.7-.8-1.3-.8c-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C50.2 469.5 50.7 468.5 50.7 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M60.5 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C62.6 472.3 61.3 471.8 60.5 470.8zM65.9 466.6v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C65.4 469.5 65.9 468.5 65.9 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M75.7 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S76.5 471.8 75.7 470.8zM81.1 466.6v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C80.6 469.5 81.1 468.5 81.1 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M91.9 456.3c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9.8-.4 1.3-.8 1.7-1.2h2.6V472h-3.3L91.9 456.3v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M103.7 456.3c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9.8-.4 1.3-.8 1.7-1.2h2.6V472h-3.3L103.7 456.3v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M114.5 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C116.6 472.3 115.3 471.8 114.5 470.8zM119.9 466.6v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C119.4 469.5 119.9 468.5 119.9 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M129.7 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C131.8 472.3 130.5 471.8 129.7 470.8zM135.1 466.6v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C134.6 469.5 135.1 468.5 135.1 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M145.9 456.3c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6V472h-3.3L145.9 456.3v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M157.7 456.3c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6V472h-3.3L157.7 456.3v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M169.5 456.3c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6V472h-3.3L169.5 456.3v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M180.3 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C182.4 472.3 181.2 471.8 180.3 470.8zM185.7 466.6v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C185.2 469.5 185.7 468.5 185.7 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M196.5 456.3c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6V472h-3.3L196.5 456.3v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M208.3 456.3c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6V472h-3.3L208.3 456.3v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M219.1 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C221.2 472.3 220 471.8 219.1 470.8zM224.6 466.6v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C224 469.5 224.6 468.5 224.6 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M234.3 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C236.4 472.3 235.2 471.8 234.3 470.8zM239.8 466.6v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C239.2 469.5 239.8 468.5 239.8 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M250.5 456.3c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6V472h-3.3L250.5 456.3v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M261.3 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C263.4 472.3 262.2 471.8 261.3 470.8zM266.8 466.6v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C266.2 469.5 266.8 468.5 266.8 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M277.5 456.3c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4v-2.5c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5V472h-3.3L277.5 456.3v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M288.3 470.8c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C290.4 472.3 289.2 471.8 288.3 470.8zM293.8 466.6v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C293.2 469.5 293.8 468.5 293.8 466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M8.5 493.1v14.8c.4-.9.6-1.9.6-3.1v-8.6C9.2 495 9 494 8.5 493.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M16.6 494.5c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4V493c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3V494.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M28.4 494.5c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4V493c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3V494.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M39.3 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C41.4 510.4 40.2 509.9 39.3 508.9zM44.7 504.8v-8.5c0-.8-.1-1.5-.3-2.1s-.7-.8-1.3-.8c-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C44.2 507.6 44.7 506.7 44.7 504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M55.5 494.5c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4V493c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.5v19.3h-3.3L55.5 494.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M66.3 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C68.4 510.4 67.2 509.9 66.3 508.9zM71.8 504.8v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C71.2 507.6 71.8 506.7 71.8 504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M81.6 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C83.7 510.4 82.4 509.9 81.6 508.9zM87 504.8v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C86.4 507.6 87 506.7 87 504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M96.8 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C98.9 510.4 97.6 509.9 96.8 508.9zM102.2 504.8v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C101.6 507.6 102.2 506.7 102.2 504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M112 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1.8-1 2.1-1.5 3.8-1.5 1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C114.1 510.4 112.8 509.9 112 508.9zM117.4 504.8v-8.5c0-.8-.1-1.5-.3-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C116.9 507.6 117.4 506.7 117.4 504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M128.2 494.5c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4V493c.6-.2 1.3-.5 2.1-.9.8-.4 1.3-.8 1.7-1.2h2.6v19.3h-3.3L128.2 494.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M140 494.5c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4V493c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3H140V494.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M150.9 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C153 510.4 151.7 509.9 150.9 508.9zM156.3 504.8v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C155.7 507.6 156.3 506.7 156.3 504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M166.1 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C168.2 510.4 166.9 509.9 166.1 508.9zM171.5 504.8v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C171 507.6 171.5 506.7 171.5 504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M182.3 494.5c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4V493c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L182.3 494.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M193.1 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C195.2 510.4 194 509.9 193.1 508.9zM198.6 504.8v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C198 507.6 198.6 506.7 198.6 504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M209.3 494.5c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4V493c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L209.3 494.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M220.2 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5S221 509.9 220.2 508.9zM225.6 504.8v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C225.1 507.6 225.6 506.7 225.6 504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M235.4 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1s-2.1 1.5-3.7 1.5C237.5 510.4 236.3 509.9 235.4 508.9zM240.8 504.8v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.4-.8-.7.0-1.1.3-1.4.8s-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C240.3 507.6 240.8 506.7 240.8 504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M251.6 494.5c-.2.1-.7.3-1.7.5-.8.2-1.2.4-1.2.4V493c.6-.2 1.3-.5 2.1-.9s1.3-.8 1.7-1.2h2.6v19.3h-3.3L251.6 494.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M262.4 508.9c-.9-1-1.3-2.4-1.3-4.1v-8.6c0-1.8.4-3.1 1.2-4.1s2.1-1.5 3.8-1.5c1.7.0 2.9.5 3.8 1.5.8 1 1.3 2.4 1.3 4.1v8.6c0 1.7-.4 3.1-1.3 4.1-.9 1-2.1 1.5-3.7 1.5C264.5 510.4 263.3 509.9 262.4 508.9zM267.9 504.8v-8.5c0-.8-.1-1.5-.4-2.1-.2-.5-.7-.8-1.3-.8-.7.0-1.1.3-1.4.8-.2.5-.3 1.2-.3 2.1v8.5c0 .8.1 1.4.4 2s.7.8 1.3.8C267.3 507.6 267.9 506.7 267.9 504.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.2 364.3c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C146.6 365.2 145.8 364.9 145.2 364.3zM148.7 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C148.4 363.4 148.7 362.8 148.7 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.7 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.7 364.3c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C164.1 365.2 163.3 364.9 162.7 364.3zM166.2 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C165.8 363.4 166.2 362.8 166.2 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M172.5 364.3c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C173.9 365.2 173.1 364.9 172.5 364.3zM176 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C175.7 363.4 176 362.8 176 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M182.3 364.3c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C183.7 365.2 182.9 364.9 182.3 364.3zM185.8 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C185.5 363.4 185.8 362.8 185.8 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M192.2 364.3c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C193.5 365.2 192.7 364.9 192.2 364.3zM195.7 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C195.3 363.4 195.7 362.8 195.7 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M202 364.3c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C203.3 365.2 202.6 364.9 202 364.3zM205.5 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C205.1 363.4 205.5 362.8 205.5 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M211.8 364.3c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C213.2 365.2 212.4 364.9 211.8 364.3zM215.3 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C215 363.4 215.3 362.8 215.3 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M222.3 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M229.9 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M236.9 364.3c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C238.3 365.2 237.5 364.9 236.9 364.3zM240.4 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C240.1 363.4 240.4 362.8 240.4 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M247.4 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M254.4 364.3c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6-.5.6-1.4 1-2.4 1C255.8 365.2 255 364.9 254.4 364.3zM257.9 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C257.5 363.4 257.9 362.8 257.9 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M264.2 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C265.6 365.2 264.8 364.9 264.2 364.3zM267.7 361.6v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C267.4 363.4 267.7 362.8 267.7 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M274.7 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M281.7 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C283 365.2 282.3 364.9 281.7 364.3zM285.2 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C284.8 363.4 285.2 362.8 285.2 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M292.2 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M299.8 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M307.4 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M314.5 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C315.8 365.2 315 364.9 314.5 364.3zM318 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C317.6 363.4 318 362.8 318 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M324.3 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C325.6 365.2 324.8 364.9 324.3 364.3zM327.8 361.6v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C327.4 363.4 327.8 362.8 327.8 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M334.7 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M342.4 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M349.4 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C350.8 365.2 350 364.9 349.4 364.3zM352.9 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C352.5 363.4 352.9 362.8 352.9 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M359.2 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C360.6 365.2 359.8 364.9 359.2 364.3zM362.7 361.6v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C362.4 363.4 362.7 362.8 362.7 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M369.7 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M376.7 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C378 365.2 377.2 364.9 376.7 364.3zM380.2 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C379.8 363.4 380.2 362.8 380.2 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M386.5 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C387.9 365.2 387.1 364.9 386.5 364.3zM390 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C389.7 363.4 390 362.8 390 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M396.3 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C397.7 365.2 396.9 364.9 396.3 364.3zM399.8 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C399.5 363.4 399.8 362.8 399.8 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M406.2 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C407.5 365.2 406.7 364.9 406.2 364.3zM409.7 361.6v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C409.3 363.4 409.7 362.8 409.7 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M416 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C417.3 365.2 416.5 364.9 416 364.3zM419.5 361.6v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C419.1 363.4 419.5 362.8 419.5 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M425.8 364.3c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C427.2 365.2 426.4 364.9 425.8 364.3zM429.3 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C429 363.4 429.3 362.8 429.3 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M436.3 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M443.9 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M451.5 355c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3V354c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V355v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M462.1 361.6v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C461.7 363.4 462.1 362.8 462.1 361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M149.4 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M156.3 388.8c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C157.7 389.8 156.9 389.5 156.3 388.8zM159.8 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C159.5 388 159.8 387.4 159.8 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M166.1 388.8c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1S166.7 389.5 166.1 388.8zM169.6 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C169.3 388 169.6 387.4 169.6 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M176.5 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M184.1 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M191.1 388.8c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C192.4 389.8 191.6 389.5 191.1 388.8zM194.6 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C194.2 388 194.6 387.4 194.6 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M200.8 388.8c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C202.2 389.8 201.4 389.5 200.8 388.8zM204.3 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C204 388 204.3 387.4 204.3 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M210.6 388.8c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C211.9 389.8 211.1 389.5 210.6 388.8zM214.1 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C213.7 388 214.1 387.4 214.1 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M220.4 388.8c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C221.7 389.8 220.9 389.5 220.4 388.8zM223.8 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C223.5 388 223.8 387.4 223.8 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M230.8 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M237.7 388.8c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C239.1 389.8 238.3 389.5 237.7 388.8zM241.2 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C240.8 388 241.2 387.4 241.2 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M248.1 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M255.7 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M262.6 388.8c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C264 389.8 263.2 389.5 262.6 388.8zM266.2 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C265.8 388 266.2 387.4 266.2 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M273 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4H273V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M280.6 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M288.2 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M295.2 388.8c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C296.5 389.8 295.7 389.5 295.2 388.8zM298.7 386.2v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C298.3 388 298.7 387.4 298.7 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M305 388.8c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C306.3 389.8 305.5 389.5 305 388.8zM308.5 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C308.1 388 308.5 387.4 308.5 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M315.3 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M322.9 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M329.9 388.8c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C331.3 389.8 330.5 389.5 329.9 388.8zM333.4 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C333 388 333.4 387.4 333.4 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M339.7 388.8c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C341 389.8 340.2 389.5 339.7 388.8zM343.2 386.2v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C342.8 388 343.2 387.4 343.2 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M350.1 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M357 388.8c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C358.4 389.8 357.6 389.5 357 388.8zM360.5 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C360.2 388 360.5 387.4 360.5 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M366.8 388.8c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C368.1 389.8 367.3 389.5 366.8 388.8zM370.3 386.2v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C369.9 388 370.3 387.4 370.3 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M376.5 388.8c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C377.9 389.8 377.1 389.5 376.5 388.8zM380 386.2v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C379.7 388 380 387.4 380 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M387 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4H387V379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M394.5 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M401.5 388.8c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C402.8 389.8 402 389.5 401.5 388.8zM405 386.2v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C404.6 388 405 387.4 405 386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M411.9 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M419.5 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M427.1 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M434.7 379.5c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V379.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M153.3 413.4c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C154.7 414.4 153.9 414 153.3 413.4zM156.8 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C156.5 412.5 156.8 411.9 156.8 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M163.8 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M170.8 413.4c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C172.2 414.4 171.4 414 170.8 413.4zM174.3 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C174 412.5 174.3 411.9 174.3 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M180.7 413.4c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C182.1 414.4 181.2 414 180.7 413.4zM184.2 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C183.8 412.5 184.2 411.9 184.2 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M190.5 413.4c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C191.9 414.4 191.1 414 190.5 413.4zM194 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C193.7 412.5 194 411.9 194 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M200.4 413.4c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C201.7 414.4 200.9 414 200.4 413.4zM203.9 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C203.5 412.5 203.9 411.9 203.9 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M210.8 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M217.9 413.4c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1S218.4 414 217.9 413.4zM221.4 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C221 412.5 221.4 411.9 221.4 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M227.7 413.4c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C229.1 414.4 228.3 414 227.7 413.4zM231.2 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C230.8 412.5 231.2 411.9 231.2 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M237.5 413.4c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C238.9 414.4 238.1 414 237.5 413.4zM241 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C240.7 412.5 241 411.9 241 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M247.4 413.4c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1S247.9 414 247.4 413.4zM250.9 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C250.5 412.5 250.9 411.9 250.9 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M257.2 413.4c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6-.5.6-1.4 1-2.4 1C258.6 414.4 257.8 414 257.2 413.4zM260.7 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C260.3 412.5 260.7 411.9 260.7 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M267.1 413.4c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C268.4 414.4 267.6 414 267.1 413.4zM270.6 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C270.2 412.5 270.6 411.9 270.6 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M277.5 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M285.2 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M292.2 413.4c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C293.6 414.4 292.8 414 292.2 413.4zM295.7 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C295.3 412.5 295.7 411.9 295.7 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M302 413.4c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C303.4 414.4 302.6 414 302 413.4zM305.5 410.7v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C305.2 412.5 305.5 411.9 305.5 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M312.5 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M320.2 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M327.8 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M334.9 413.4c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C336.2 414.4 335.4 414 334.9 413.4zM338.4 410.7v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C338 412.5 338.4 411.9 338.4 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M345.3 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M353 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4H353V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M360 413.4c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C361.4 414.4 360.6 414 360 413.4zM363.5 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C363.2 412.5 363.5 411.9 363.5 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M370.5 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M378.2 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M385.8 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M393.5 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M400.5 413.4c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C401.9 414.4 401 414 400.5 413.4zM404 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C403.6 412.5 404 411.9 404 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M411 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4H411V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M418.6 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M425.7 413.4c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C427 414.4 426.2 414 425.7 413.4zM429.2 410.7v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C428.8 412.5 429.2 411.9 429.2 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M436.1 404.1c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V404.1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M446.7 410.7v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C446.3 412.5 446.7 411.9 446.7 410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M135.5 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C135.1 437.1 135.5 436.5 135.5 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M141.8 437.9c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C143.2 438.9 142.4 438.6 141.8 437.9zM145.3 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C145 437.1 145.3 436.5 145.3 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M151.7 437.9c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C153 438.9 152.2 438.6 151.7 437.9zM155.2 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C154.8 437.1 155.2 436.5 155.2 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M162.2 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M169.2 437.9c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1S169.8 438.6 169.2 437.9zM172.7 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C172.3 437.1 172.7 436.5 172.7 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M179.1 437.9c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C180.4 438.9 179.6 438.6 179.1 437.9zM182.6 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C182.2 437.1 182.6 436.5 182.6 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M188.9 437.9c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C190.3 438.9 189.5 438.6 188.9 437.9zM192.4 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C192.1 437.1 192.4 436.5 192.4 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M198.8 437.9c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C200.1 438.9 199.3 438.6 198.8 437.9zM202.3 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C201.9 437.1 202.3 436.5 202.3 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M208.6 437.9c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C210 438.9 209.2 438.6 208.6 437.9zM212.1 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C211.8 437.1 212.1 436.5 212.1 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M218.5 437.9c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C219.8 438.9 219 438.6 218.5 437.9zM222 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C221.6 437.1 222 436.5 222 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M229 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4H229V428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M236.6 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M243.7 437.9c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C245 438.9 244.2 438.6 243.7 437.9zM247.2 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C246.8 437.1 247.2 436.5 247.2 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M254.2 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M261.2 437.9c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C262.6 438.9 261.8 438.6 261.2 437.9zM264.7 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.8.5C264.3 437.1 264.7 436.5 264.7 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M271.1 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C272.4 438.9 271.6 438.6 271.1 437.9zM274.6 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C274.2 437.1 274.6 436.5 274.6 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M280.9 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C282.3 438.9 281.5 438.6 280.9 437.9zM284.4 435.3v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C284 437.1 284.4 436.5 284.4 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M290.8 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C292.1 438.9 291.3 438.6 290.8 437.9zM294.3 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C293.9 437.1 294.3 436.5 294.3 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M301.3 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M308.9 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M316 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C317.3 438.9 316.5 438.6 316 437.9zM319.5 435.3v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C319.1 437.1 319.5 436.5 319.5 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M325.8 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C327.2 438.9 326.4 438.6 325.8 437.9zM329.3 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C329 437.1 329.3 436.5 329.3 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M336.3 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M343.3 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C344.7 438.9 343.9 438.6 343.3 437.9zM346.8 435.3v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C346.5 437.1 346.8 436.5 346.8 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M353.8 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M360.9 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C362.2 438.9 361.4 438.6 360.9 437.9zM364.4 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C364 437.1 364.4 436.5 364.4 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M371.4 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M379 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4H379V428.6v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M386.7 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M393.8 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C395.1 438.9 394.3 438.6 393.8 437.9zM397.3 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C396.9 437.1 397.3 436.5 397.3 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M403.6 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C405 438.9 404.2 438.6 403.6 437.9zM407.1 435.3v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C406.7 437.1 407.1 436.5 407.1 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M414.1 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M421.1 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C422.5 438.9 421.7 438.6 421.1 437.9zM424.6 435.3v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C424.3 437.1 424.6 436.5 424.6 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M431 437.9c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C432.3 438.9 431.5 438.6 431 437.9zM434.5 435.3v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C434.1 437.1 434.5 436.5 434.5 435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M441.5 428.6c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.2v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V428.6v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M15.1 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st180",
    d: "M22.7 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M30.3 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M37.3 462.5c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.3-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6-.5.6-1.4 1-2.4 1C38.7 463.5 37.9 463.1 37.3 462.5zM40.8 459.8v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C40.5 461.6 40.8 461 40.8 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M47.7 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M55.3 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st185",
    d: "M97.1 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C98.4 463.5 97.6 463.1 97.1 462.5zM100.6 459.8v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C100.2 461.6 100.6 461 100.6 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M106.9 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C108.2 463.5 107.4 463.1 106.9 462.5zM110.4 459.8v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C110 461.6 110.4 461 110.4 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M116.6 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C118 463.5 117.2 463.1 116.6 462.5zM120.1 459.8v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C119.8 461.6 120.1 461 120.1 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M127 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4H127C127 463.3 127 453.2 127 453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M134 462.5c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1S134.6 463.1 134 462.5zM137.5 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C137.2 461.6 137.5 461 137.5 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M143.8 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C145.2 463.5 144.4 463.1 143.8 462.5zM147.3 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C146.9 461.6 147.3 461 147.3 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M153.6 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1S154.1 463.1 153.6 462.5zM157.1 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C156.7 461.6 157.1 461 157.1 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M163.4 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C164.7 463.5 163.9 463.1 163.4 462.5zM166.9 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C166.5 461.6 166.9 461 166.9 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M173.1 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C174.5 463.5 173.7 463.1 173.1 462.5zM176.6 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C176.3 461.6 176.6 461 176.6 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M182.9 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C184.3 463.5 183.5 463.1 182.9 462.5zM186.4 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C186.1 461.6 186.4 461 186.4 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M193.3 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M200.9 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M207.9 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C209.3 463.5 208.5 463.1 207.9 462.5zM211.4 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C211.1 461.6 211.4 461 211.4 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M217.7 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C219.1 463.5 218.3 463.1 217.7 462.5zM221.2 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C220.8 461.6 221.2 461 221.2 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M228.1 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M235.7 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M243.3 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M250.3 462.5c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C251.6 463.5 250.8 463.1 250.3 462.5zM253.8 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C253.4 461.6 253.8 461 253.8 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M260.7 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M268.3 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M275.3 462.5c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C276.6 463.5 275.8 463.1 275.3 462.5zM278.8 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C278.4 461.6 278.8 461 278.8 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M285 462.5c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C286.4 463.5 285.6 463.1 285 462.5zM288.5 459.8v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C288.2 461.6 288.5 461 288.5 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M295.5 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M302.4 462.5c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C303.8 463.5 303 463.1 302.4 462.5zM305.9 459.8v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C305.6 461.6 305.9 461 305.9 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M312.8 453.2c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V453.2v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M319.8 462.5c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C321.2 463.5 320.4 463.1 319.8 462.5zM323.3 459.8v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C323 461.6 323.3 461 323.3 459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M8.9 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8H11v12.4H8.9V477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M15.9 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.3-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6-.5.6-1.4 1-2.4 1C17.2 488 16.4 487.7 15.9 487zM19.3 484.4v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C19 486.2 19.3 485.6 19.3 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M25.6 487c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C27 488 26.2 487.7 25.6 487zM29.1 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C28.8 486.2 29.1 485.6 29.1 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M35.4 487c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.3-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6-.5.6-1.4 1-2.4 1C36.8 488 36 487.7 35.4 487zM38.9 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C38.6 486.2 38.9 485.6 38.9 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M45.2 487c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.3-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6-.5.6-1.4 1-2.4 1C46.6 488 45.8 487.7 45.2 487zM48.7 484.4v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.8.5C48.4 486.2 48.7 485.6 48.7 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st195",
    d: "M55 487c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.3-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6-.5.6-1.4 1-2.4 1C56.4 488 55.6 487.7 55 487zM58.5 484.4v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.8.5C58.2 486.2 58.5 485.6 58.5 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M64.8 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.3-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C66.2 488 65.4 487.7 64.8 487zM68.3 484.4v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.8.5C68 486.2 68.3 485.6 68.3 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M75.3 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1C75.3 487.8 75.3 477.8 75.3 477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st198",
    d: "M82.9 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8H85v12.4h-2.1C82.9 487.8 82.9 477.8 82.9 477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M90.5 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1C90.5 487.8 90.5 477.8 90.5 477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st200",
    d: "M97.5 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C98.8 488 98 487.7 97.5 487zM101 484.4v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C100.6 486.2 101 485.6 101 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st201",
    d: "M107.9 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1C107.9 487.8 107.9 477.8 107.9 477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M114.9 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C116.2 488 115.4 487.7 114.9 487zM118.4 484.4v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C118 486.2 118.4 485.6 118.4 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st203",
    d: "M124.7 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C126 488 125.2 487.7 124.7 487zM128.2 484.4v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C127.8 486.2 128.2 485.6 128.2 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M134.5 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C135.8 488 135 487.7 134.5 487zM138 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C137.6 486.2 138 485.6 138 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M144.9 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M152.5 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M159.5 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C160.9 488 160.1 487.7 159.5 487zM163 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C162.6 486.2 163 485.6 163 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M169.9 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M176.9 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C178.3 488 177.5 487.7 176.9 487zM180.4 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C180.1 486.2 180.4 485.6 180.4 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M186.7 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C188.1 488 187.3 487.7 186.7 487zM190.2 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C189.8 486.2 190.2 485.6 190.2 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M196.5 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C197.9 488 197.1 487.7 196.5 487zM2e2 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C199.6 486.2 2e2 485.6 2e2 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M206.3 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C207.7 488 206.9 487.7 206.3 487zM209.8 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C209.4 486.2 209.8 485.6 209.8 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M216.7 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M224.3 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M231.3 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C232.7 488 231.9 487.7 231.3 487zM234.8 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C234.5 486.2 234.8 485.6 234.8 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M241.1 487c-.6-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7s1.4-1 2.4-1c1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C242.5 488 241.7 487.7 241.1 487zM244.6 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C244.3 486.2 244.6 485.6 244.6 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M251.6 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M258.5 487c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C259.9 488 259.1 487.7 258.5 487zM262 484.4v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3s.4.5.9.5C261.7 486.2 262 485.6 262 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M269 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4H269V477.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M276 487c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C277.3 488 276.5 487.7 276 487zM279.5 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C279.1 486.2 279.5 485.6 279.5 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M285.7 487c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.3-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C287.1 488 286.3 487.7 285.7 487zM289.2 484.4v-5.5c0-.5-.1-1-.2-1.3-.2-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5-.1.3-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.9.5C288.9 486.2 289.2 485.6 289.2 484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M296.2 477.8c-.1.1-.5.2-1.1.4-.5.1-.8.2-.8.3v-1.6c.4-.1.9-.3 1.3-.6.5-.3.8-.5 1.1-.8h1.6v12.4h-2.1V477.8v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M303.2 487c-.5-.6-.8-1.5-.8-2.6v-5.5c0-1.1.3-2 .8-2.7.5-.6 1.4-1 2.4-1 1.1.0 1.9.3 2.4 1 .5.6.8 1.5.8 2.7v5.5c0 1.1-.3 2-.8 2.6s-1.4 1-2.4 1C304.5 488 303.7 487.7 303.2 487zM306.7 484.4v-5.5c0-.5-.1-1-.2-1.3-.1-.3-.4-.5-.9-.5-.4.0-.7.2-.9.5s-.2.8-.2 1.3v5.5c0 .5.1.9.2 1.3.2.4.4.5.8.5C306.3 486.2 306.7 485.6 306.7 484.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 61.6457,
    cy: 1759.5319,
    r: 104.8722,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M262 68.2l.5.9-66.7 38.7 70.5 40.9c.2.1.3.3.3.5s-.1.4-.3.4l-76.1 42.6V250c0 .2-.1.4-.3.4-.2.1-.4.1-.5.0l-44.1-25.9v75.6l12 7.8c.1.1.2.3.2.4v21.5h-1v-21.2l-12-7.8c-.1-.1-.2-.3-.2-.4v-76.8c0-.2.1-.4.3-.4.2-.1.4-.1.5.0l44.1 25.9v-57.2c0-.2.1-.4.3-.4l75.5-42.3-70.5-40.9c-.2-.1-.3-.3-.3-.4.0-.2.1-.4.3-.5L262 68.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 113.5276,
    cy: 1783.4286,
    r: 103.9246,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M196.6 57.7l61.9 36.1c.2.1.3.3.3.4.0.2-.1.4-.3.5l-78.2 45.8c-.2.1-.4.1-.5.0l-29.7-17.9-39.9 22.6v23.7l20 11.3c.2.1.3.3.3.4v45.6c0 .2-.1.4-.3.4-.2.1-.4.1-.5.0l-14.6-7.9v79.1c0 .2-.1.4-.3.5-.2.1-.4.1-.5.0L90 283.8l.5-.9 23.4 14v-79.1c0-.2.1-.4.3-.4.2-.1.3-.1.5.0l14.6 7.9v-44.4l-20-11.3c-.2-.1-.3-.3-.3-.4v-24.3c0-.2.1-.4.3-.4l40.5-22.9c.2-.1.4-.1.5.0l29.6 17.9L257 94.3l-61.1-35.6L196.6 57.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 147.8326,
    cy: 1812.4304,
    r: 101.9687,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M99.6 68.8l51.2 29.9c.2.1.3.3.3.5.0.2-.1.4-.3.4L110.7 122l70 40.5c.2.1.3.3.3.5s-.1.4-.3.5l-20.8 11.3v112.7c0 .2-.1.4-.3.4-.2.1-.4.1-.5.0l-28.3-16.7v74.2h-1v-75.1c0-.2.1-.4.3-.5.2-.1.4-.1.5.0l28.2 16.7V174.3c0-.2.1-.4.3-.5l20.3-11-70-40.4c-.2-.1-.3-.3-.3-.5s.1-.4.3-.4l40.1-22.4L99.1 69.7 99.6 68.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 58.4876,
    cy: 1845.0754,
    r: 101.8253,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M281 105.5l.5.9-81.1 45.1 51.1 29c.2.1.3.3.3.5s-.1.4-.3.4l-40.6 22.3v28.6c0 .2-.1.4-.3.4-.2.1-.4.1-.5.0l-31.8-18.6v81.1l23.6 13.7c.2.1.3.3.3.5v64.5h-1v-64.2l-23.6-13.7c-.2-.1-.3-.3-.3-.5v-82.3c0-.2.1-.4.3-.4.2-.1.4-.1.5.0l31.8 18.6v-28.1c0-.2.1-.4.3-.5l40.1-22-51.1-29c-.2-.1-.3-.3-.3-.4.0-.2.1-.4.3-.4L281 105.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 158.3072,
    cy: 1768.222,
    r: 64.7383,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M171.1 86.8l9.2 6.2c.1.1.2.3.2.4.0.2-.1.3-.3.4l-29.6 16.7 19.9 11.9c.2.1.3.3.3.5.0.2-.1.4-.3.4l-39.7 21.6 19.9 12.3c.2.1.3.3.3.5.0.2-.1.4-.3.4l-10.7 5.6v38.6c0 .2-.1.4-.3.4-.2.1-.4.1-.5.0l-49.4-29.4v65.1c0 .2-.1.4-.2.4-.2.1-.3.1-.5.0l-10.6-5.1.4-.9 9.8 4.7v-65.2c0-.2.1-.4.3-.4s.4-.1.5.0l49.4 29.4v-38c0-.2.1-.4.3-.5l10.2-5.3-19.9-12.3c-.2-.1-.3-.3-.3-.5.0-.2.1-.4.3-.4l39.7-21.6L149.4 111c-.2-.1-.3-.3-.3-.5.0-.2.1-.4.3-.4L179 93.4l-8.5-5.7L171.1 86.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: -22.4274,
    cy: 1829.6053,
    r: 82.0364,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M379 140.8l.5.9-18.8 10.9 30 17.2c.2.1.3.3.3.4.0.2-.1.4-.3.4l-120.4 67.9v57.8c0 .2-.1.4-.3.4-.2.1-.4.1-.5.0l-38.8-22.2v33h-1v-33.9c0-.2.1-.4.3-.4.2-.1.4-.1.5.0l38.8 22.2v-57.2c0-.2.1-.4.3-.4l119.9-67.6-30-17.2c-.2-.1-.3-.3-.3-.4s.1-.4.3-.4L379 140.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 19.7595,
    cy: 1803.6271,
    r: 112.2275,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M347.3 81.3l.6.9-58.3 38.9 41.5 23.5c.2.1.3.3.3.4.0.2-.1.4-.3.4L282 174.6c-.2.1-.4.1-.5.0l-35.3-20.3-61.7 34.7v35l25.6 13.7c.2.1.3.3.3.5v34.3c0 .2-.1.4-.3.5-.2.1-.4.1-.5.0l-14.6-7.9v79.6c0 .2-.1.4-.3.5-.2.1-.4.1-.5.0l-14.6-8.8v12.7h-1v-13.6c0-.2.1-.4.3-.5.2-.1.4-.1.5.0l14.6 8.8v-79.6c0-.2.1-.4.3-.4.2-.1.4-.1.5.0l14.6 7.9v-33.1l-25.6-13.7c-.2-.1-.3-.3-.3-.5v-35.6c0-.2.1-.4.3-.4l62.2-35c.2-.1.4-.1.5.0l35.3 20.3 48.1-28.6-41.5-23.5c-.2-.1-.3-.3-.3-.4.0-.2.1-.3.2-.4L347.3 81.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 62.7776,
    cy: 1843.3403,
    r: 86.0558,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M190.8 121.7l40 23.3c.2.1.3.3.3.4.0.2-.1.4-.3.5l-40.1 22.4 70 40.5c.2.1.3.3.3.5s-.1.4-.3.4L239.9 221v133.2h-1V220.7c0-.2.1-.4.3-.5l20.3-11-70-40.4c-.2-.1-.3-.3-.3-.4s.1-.4.3-.4l40.1-22.4-39.3-22.9L190.8 121.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: -37.6674,
    cy: 1860.8403,
    r: 70.7898,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M352 179.8c.1.0.2.0.3.1l38.8 23.2-.5.9L352 180.9l-50.4 28 30 17.9c.2.1.3.3.3.5s-.1.4-.3.4L291 250v23.5c0 .2-.1.4-.3.4-.2.1-.4.1-.5.0l-29.1-17.1v50.4l40.7 23-.5.9L260.3 308c-.2-.1-.3-.3-.3-.4v-51.7c0-.2.1-.4.3-.4s.4-.1.5.0l29.1 17.1v-22.9c0-.2.1-.4.3-.5l40.1-22-30-17.9c-.2-.1-.3-.3-.3-.4.0-.2.1-.4.3-.4l51.5-28.6C351.9 179.8 351.9 179.8 352 179.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 28.1025,
    cy: 1838.3354,
    r: 74.3777,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M267.7 135.6l31.6 18.4c.2.1.3.3.3.4.0.2-.1.4-.3.5l-36.2 20.3 19.9 11.9c.2.1.3.3.3.5s-.1.4-.3.4l-39.7 21.6 20.2 11.7c.2.1.3.3.3.5s-.1.4-.3.4l-11.1 6.1v23c0 .2-.1.4-.3.4-.2.1-.4.1-.5.0l-30.6-18.2v96.8h-1v-97.7c0-.2.1-.4.3-.4.2-.1.4-.1.5.0l30.6 18.2V228c0-.2.1-.4.3-.5l10.5-5.8L242 210c-.2-.1-.3-.3-.3-.5s.1-.4.3-.4l39.7-21.6-19.9-11.8c-.2-.1-.3-.3-.3-.5.0-.2.1-.4.3-.4l36.2-20.3-30.8-18L267.7 135.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 48.7226,
    cy: 1962.0953,
    r: 4.0285,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st214",
    d: "M237.8 352.3c.5.0 1.1.2 1.6.5 1.9 1.1 3.3 3.6 3.3 5.7.0 1.6-.9 2.7-2.2 2.7-.5.0-1.1-.2-1.6-.5-1.9-1.1-3.3-3.6-3.3-5.7C235.6 353.4 236.5 352.3 237.8 352.3zM240.5 360.1c.7.0 1.2-.6 1.2-1.6.0-1.7-1.3-3.9-2.8-4.8-.4-.2-.8-.4-1.1-.4-.7.0-1.2.6-1.2 1.6.0 1.7 1.3 3.9 2.8 4.8C239.8 360 240.2 360.1 240.5 360.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: -15.9774,
    cy: 1938.4753,
    r: 4.0242,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M302.5 328.7c.5.0 1.1.2 1.6.5 1.8 1.1 3.3 3.6 3.3 5.7.0 1.6-.9 2.7-2.2 2.7-.5.0-1.1-.2-1.6-.5-1.9-1.1-3.3-3.6-3.3-5.7C300.3 329.7 301.2 328.7 302.5 328.7zM305.2 336.5c.7.0 1.2-.6 1.2-1.6.0-1.7-1.3-3.9-2.8-4.8-.4-.2-.8-.4-1.1-.4-.7.0-1.2.6-1.2 1.6.0 1.7 1.3 3.9 2.8 4.8C304.5 336.4 304.9 336.5 305.2 336.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 67.3926,
    cy: 1937.8154,
    r: 4.023,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M219.1 328c.5.0 1.1.2 1.6.5 1.9 1.1 3.3 3.6 3.3 5.7.0 1.6-.9 2.7-2.2 2.7-.5.0-1.1-.2-1.6-.5-1.9-1.1-3.3-3.6-3.3-5.7C216.9 329.1 217.8 328 219.1 328zM221.9 335.8c.7.0 1.2-.6 1.2-1.6.0-1.7-1.3-3.9-2.8-4.8-.4-.2-.8-.4-1.1-.4-.7.0-1.2.6-1.2 1.6.0 1.7 1.3 3.9 2.8 4.8C221.2 335.7 221.5 335.8 221.9 335.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 85.8626,
    cy: 1982.1654,
    r: 4.0285,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M200.7 372.4c.5.0 1.1.2 1.6.5 1.9 1.1 3.3 3.6 3.3 5.7.0 1.6-.9 2.7-2.2 2.7-.5.0-1.1-.2-1.6-.5-1.9-1.1-3.3-3.6-3.3-5.7C198.5 373.4 199.3 372.4 200.7 372.4zM203.4 380.2c.7.0 1.2-.6 1.2-1.6.0-1.7-1.3-3.9-2.8-4.8-.4-.2-.8-.4-1.1-.4-.7.0-1.2.6-1.2 1.6.0 1.7 1.3 3.9 2.8 4.8C202.7 380.1 203.1 380.2 203.4 380.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 108.7426,
    cy: 1957.2053,
    r: 4.0218,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st218",
    d: "M177.8 347.4c.5.0 1.1.2 1.6.5 1.9 1.1 3.3 3.6 3.3 5.7.0 1.6-.9 2.7-2.2 2.7-.5.0-1.1-.2-1.6-.5-1.9-1.1-3.3-3.6-3.3-5.7C175.6 348.4 176.4 347.4 177.8 347.4zM180.5 355.2c.7.0 1.2-.6 1.2-1.6.0-1.7-1.3-3.9-2.8-4.8-.4-.2-.8-.4-1.1-.4-.7.0-1.2.6-1.2 1.6.0 1.7 1.3 3.9 2.8 4.8C179.8 355.1 180.2 355.2 180.5 355.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 57.4926,
    cy: 1915.4254,
    r: 4.0286,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st219",
    d: "M229 305.6c.5.0 1.1.2 1.6.5 1.9 1.1 3.3 3.6 3.3 5.7.0 1.6-.9 2.7-2.2 2.7-.5.0-1.1-.2-1.6-.5-1.9-1.1-3.3-3.6-3.3-5.7C226.8 306.7 227.7 305.6 229 305.6zM231.8 313.5c.7.0 1.2-.6 1.2-1.6.0-1.7-1.3-3.9-2.8-4.8-.4-.2-.8-.4-1.1-.4-.7.0-1.2.6-1.2 1.6.0 1.7 1.3 3.9 2.8 4.8C231.1 313.3 231.4 313.5 231.8 313.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 130.7826,
    cy: 1937.6053,
    r: 4.0216,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st220",
    d: "M155.7 327.8c.5.0 1.1.2 1.6.5 1.9 1.1 3.3 3.6 3.3 5.7.0 1.6-.9 2.7-2.2 2.7-.5.0-1.1-.2-1.6-.5-1.9-1.1-3.3-3.6-3.3-5.7C153.5 328.9 154.4 327.8 155.7 327.8zM158.5 335.6c.7.0 1.2-.6 1.2-1.6.0-1.7-1.3-3.9-2.8-4.8-.4-.2-.8-.4-1.1-.4-.7.0-1.2.6-1.2 1.6.0 1.7 1.3 3.9 2.8 4.8C157.8 335.5 158.1 335.6 158.5 335.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 157.1326,
    cy: 1953.3453,
    r: 4.0285,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st221",
    d: "M129.4 343.5c.5.0 1.1.2 1.6.5 1.9 1.1 3.3 3.6 3.3 5.7.0 1.6-.9 2.7-2.2 2.7-.5.0-1.1-.2-1.6-.5-1.9-1.1-3.3-3.6-3.3-5.7C127.2 344.6 128.1 343.5 129.4 343.5zM132.1 351.4c.7.0 1.2-.6 1.2-1.6.0-1.7-1.3-3.9-2.8-4.8-.4-.2-.8-.4-1.1-.4-.7.0-1.2.6-1.2 1.6.0 1.7 1.3 3.9 2.8 4.8C131.4 351.3 131.8 351.4 132.1 351.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 200.2526,
    cy: 1887.4354,
    r: 4.023,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st222",
    d: "M86.3 277.6c.5.0 1.1.2 1.6.5 1.9 1.1 3.3 3.6 3.3 5.7.0 1.6-.9 2.7-2.2 2.7-.5.0-1.1-.2-1.6-.5-1.8-1.1-3.3-3.6-3.3-5.7C84.1 278.7 85 277.6 86.3 277.6zM89 285.5c.7.0 1.2-.6 1.2-1.6.0-1.7-1.3-3.9-2.8-4.8-.4-.2-.8-.4-1.1-.4-.7.0-1.2.6-1.2 1.6.0 1.7 1.3 3.9 2.8 4.8C88.3 285.3 88.7 285.5 89 285.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 211.0226,
    cy: 1838.0054,
    r: 4.0286,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st223",
    d: "M75.5 228.2c.5.0 1.1.2 1.6.5 1.9 1.1 3.3 3.6 3.3 5.7.0 1.6-.9 2.7-2.2 2.7-.5.0-1.1-.2-1.6-.5-1.8-1.1-3.3-3.6-3.3-5.7C73.3 229.2 74.2 228.2 75.5 228.2zM78.2 236c.7.0 1.2-.6 1.2-1.6.0-1.7-1.3-3.9-2.8-4.8-.4-.2-.8-.4-1.1-.4-.7.0-1.2.6-1.2 1.6.0 1.7 1.3 3.9 2.8 4.8C77.5 235.9 77.9 236 78.2 236z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 191.2026,
    cy: 1673.3623,
    r: 4.0096,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M96.7 65c1.2.0 2.4.3 3.3.8 1 .6 1.5 1.3 1.5 2.2.0.8-.5 1.6-1.5 2.2-1.8 1-4.8 1-6.6.0-1-.6-1.5-1.4-1.5-2.2s.5-1.6 1.5-2.2C94.3 65.3 95.4 65 96.7 65zm0 5c1.1.0 2-.2 2.8-.7.6-.4 1-.8 1-1.3.0-.5-.4-.9-1-1.3-1.5-.8-4.1-.9-5.6.0-.6.4-1 .8-1 1.3.0.5.4.9 1 1.3C94.7 69.7 95.6 70 96.7 70z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 119.6526,
    cy: 1691.0686,
    r: 4.0129,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st225",
    d: "M168.2 82.7c1.2.0 2.4.3 3.3.8 1 .6 1.5 1.3 1.5 2.2.0.8-.5 1.6-1.5 2.2-1.8 1-4.8 1-6.6.0-1-.6-1.5-1.4-1.5-2.2.0-.9.5-1.6 1.5-2.2C165.8 83 167 82.7 168.2 82.7zM168.3 87.7c1.1.0 2-.2 2.8-.7.6-.4 1-.8 1-1.3s-.4-.9-1-1.3c-1.5-.9-4.1-.9-5.6.0-.6.4-1 .8-1 1.3.0.5.4.9 1 1.3C166.2 87.4 167.2 87.7 168.3 87.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 99.3626,
    cy: 1725.6522,
    r: 4.0139,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st226",
    d: "M188.5 117.3c1.2.0 2.4.3 3.3.8 1 .6 1.5 1.4 1.5 2.2s-.5 1.6-1.5 2.2c-1.8 1-4.8 1-6.6.0-1-.6-1.5-1.4-1.5-2.2.0-.8.5-1.6 1.5-2.2C186.1 117.6 187.3 117.3 188.5 117.3zM188.6 122.3c1.1.0 2-.2 2.8-.7.6-.4 1-.8 1-1.3s-.4-.9-1-1.3c-1.5-.8-4.1-.9-5.6.0-.6.4-1 .8-1 1.3s.4.9 1 1.3C186.5 122 187.5 122.3 188.6 122.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 94.1126,
    cy: 1662.1422,
    r: 4.0096,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st227",
    d: "M193.8 53.8c1.2.0 2.4.3 3.3.8 1 .6 1.5 1.4 1.5 2.2.0.9-.5 1.6-1.5 2.2-1.8 1-4.8 1-6.6.0-1-.6-1.5-1.4-1.5-2.2.0-.8.5-1.6 1.5-2.2C191.4 54.1 192.5 53.8 193.8 53.8zM193.8 58.7c1.1.0 2-.2 2.8-.6.6-.4 1-.8 1-1.3.0-.5-.4-.9-1-1.3-1.5-.9-4.1-.9-5.6.0-.6.4-1 .8-1 1.3s.4.9 1 1.3C191.8 58.5 192.7 58.7 193.8 58.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 23.6126,
    cy: 1672.5522,
    r: 4.0096,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st228",
    d: "M264.3 64.2c1.2.0 2.4.3 3.3.8 1 .6 1.5 1.3 1.5 2.2.0.9-.5 1.6-1.5 2.2-1.8 1-4.8 1-6.6.0-1-.6-1.5-1.3-1.5-2.2.0-.8.5-1.6 1.5-2.2C261.9 64.5 263 64.2 264.3 64.2zm0 5c1 0 2-.2 2.8-.7.6-.4 1-.8 1-1.3.0-.5-.4-.9-1-1.3-1.5-.8-4.1-.9-5.6.0-.6.4-1 .8-1 1.3.0.5.4.9 1 1.3C262.3 68.9 263.2 69.2 264.3 69.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 5.0126,
    cy: 1709.5242,
    r: 4.0103,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st229",
    d: "M282.8 101.2c1.2.0 2.4.3 3.3.8 1 .6 1.5 1.4 1.5 2.2s-.5 1.6-1.5 2.2c-1.8 1-4.8 1-6.6.0-1-.6-1.5-1.4-1.5-2.2.0-.8.5-1.6 1.5-2.2C280.5 101.4 281.6 101.2 282.8 101.2zM282.9 106.1c1 0 2-.2 2.8-.6.6-.4 1-.8 1-1.3s-.4-.9-1-1.3c-1.5-.9-4.1-.9-5.6.0-.6.4-1 .8-1 1.3.0.5.4.9 1 1.3C280.8 105.9 281.8 106.1 282.9 106.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_27_",
    cx: -62.0574,
    cy: 1685.6361,
    r: 4.0045,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st230",
    d: "M349.9 77.3c1.2.0 2.4.3 3.3.8 1 .6 1.5 1.4 1.5 2.2s-.5 1.6-1.5 2.2c-1.8 1-4.8 1-6.6.0-1-.6-1.5-1.4-1.5-2.2s.5-1.6 1.5-2.2C347.5 77.6 348.7 77.3 349.9 77.3zM350 82.2c1 0 2-.2 2.8-.6.6-.4 1-.8 1-1.3.0-.5-.4-1-1-1.3-1.5-.8-4.1-.9-5.6.0-.6.4-1 .8-1 1.3.0.5.4.9 1 1.3C347.9 82 348.9 82.2 350 82.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_28_",
    cx: 22.8326,
    cy: 1740.1323,
    r: 4.0096,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st231",
    d: "M265 131.8c1.2.0 2.4.3 3.3.8 1 .6 1.5 1.4 1.5 2.2.0.8-.5 1.6-1.5 2.2-1.8 1-4.8 1-6.6.0-1-.6-1.5-1.4-1.5-2.2.0-.9.5-1.6 1.5-2.2C262.6 132.1 263.8 131.8 265 131.8zM265.1 136.7c1 0 2-.2 2.8-.7.6-.4 1-.8 1-1.3.0-.5-.4-.9-1-1.3-1.5-.8-4.1-.8-5.6.0-.6.4-1 .8-1 1.3s.4.9 1 1.3C263 136.5 264 136.7 265.1 136.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_29_",
    cx: -93.5574,
    cy: 1745.1073,
    r: 4.0133,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M381.4 136.8c1.2.0 2.4.3 3.3.8 1 .6 1.5 1.3 1.5 2.2.0.8-.5 1.6-1.5 2.2-1.8 1-4.8 1-6.6.0-1-.6-1.5-1.4-1.5-2.2.0-.9.5-1.6 1.5-2.2C379 137 380.2 136.8 381.4 136.8zM381.5 141.7c1 0 2-.2 2.8-.6.6-.4 1-.8 1-1.3.0-.5-.4-.9-1-1.3-1.5-.8-4.1-.9-5.6.0-.6.4-1 .8-1 1.3.0.5.4.9 1 1.3C379.4 141.5 380.4 141.7 381.5 141.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_30_",
    cx: -104.9674,
    cy: 1810.2423,
    r: 4.0096,
    gradientTransform: "matrix(-1 0 0 1 287.8926 -1605.3752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e1f6f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1041,
    style: {
      stopColor: "#d2f3f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    style: {
      stopColor: "#abecf1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5789,
    style: {
      stopColor: "#6ce0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9153,
    style: {
      stopColor: "#17cfdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st233",
    d: "M392.8 201.9c1.2.0 2.4.3 3.3.8 1 .6 1.5 1.4 1.5 2.2.0.9-.5 1.6-1.5 2.2-1.8 1-4.8 1-6.6.0-1-.6-1.5-1.4-1.5-2.2.0-.9.5-1.6 1.5-2.2C390.4 202.2 391.6 201.9 392.8 201.9zM392.9 206.8c1 0 2-.2 2.8-.6.6-.4 1-.8 1-1.3.0-.5-.4-.9-1-1.3-1.5-.9-4.1-.9-5.6.0-.6.4-1 .8-1 1.3.0.5.4.9 1 1.3C390.8 206.6 391.8 206.8 392.9 206.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage01Layer1);
export default __webpack_public_path__ + "static/media/image-01-layer-1.e9744687c7d62e7f04371c06403eef24.svg";
export { ForwardRef as ReactComponent };